var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,11h8V3H3V11z M5,5h4v4H5V5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,21h8v-8H3V21z M5,15h4v4H5V15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,3v8h8V3H13z M19,9h-4V5h4V9z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 19,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 13,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 15,
    y: 15
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 13,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 15,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 17,
    y: 17
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 17,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 19,
    y: 15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr_code.9fd4ebb9e0ad903e1b64a6eff072b095.svg";
export { ForwardRef as ReactComponent };